import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FiDatabase } from 'react-icons/fi';
import NodeWrapper from './NodeWrapper';
import { getNodeAccent } from '../config/nodeVisualConfig';
import { dataSourceTitle } from '../utils/nodeUtils';

const DataSourceNode = memo(({ data, selected }) => {
  const accent = getNodeAccent('data_source', data);
  return (
    <NodeWrapper
        selected={selected}
        title={dataSourceTitle({ data })}
        type="Data Source"
        accent={accent}
        icon={FiDatabase}
    >
        <div className="space-y-2">
            <div className="flex items-center justify-between mb-2 gap-2">
                <div className="flex items-center gap-2">
                    <span className="text-[10px] uppercase font-bold text-fg-3">Type</span>
                    {data.isSecondary ? (
                        <span className="ds-badge xs warn">SECONDARY</span>
                    ) : (
                        <span className="ds-badge xs profit">PRIMARY</span>
                    )}
                </div>
                <span className="text-[10px] font-bold bg-bg-3 text-fg-2 px-2 py-0.5 rounded-md">
                   {data.timeframe || '5m'}
                </span>
            </div>

            <div className="bg-bg-3 rounded-lg p-2 border border-[var(--divider)]">
                <span className="text-[10px] uppercase font-bold text-fg-3 block mb-1">Available Fields</span>
                <div className="grid grid-cols-2 gap-1">
                    {['OPEN', 'HIGH', 'LOW', 'CLOSE', 'VOLUME'].map(field => (
                        <div key={field} className="flex items-center text-[9px] font-mono text-fg-2">
                            <div className="w-1 h-1 rounded-full bg-fg-3 mr-1.5"></div>
                            {field}
                        </div>
                    ))}
                </div>
            </div>
        </div>

        {/* Source only has Output — handle tinted to the node's classification accent */}
        <Handle
            type="source"
            id="close"
            position={Position.Right}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />
    </NodeWrapper>
  );
});

export default DataSourceNode;
